<template>
  <div class="outer">
    <el-carousel height="5.5rem">
      <el-carousel-item v-for="item in 6" :key="item">
        <img src="../assets/image/lunbotu.png" style="width: 100%;height: 100%;" alt="">
      </el-carousel-item>
    </el-carousel>
    <div class="content">
      <div class="center">
        <div class="zhanshi flex-row justify-between">
          <div class="flex-col">
            <img src="../assets/image/z-1.png" alt="" class="img-item_1" />
            <!-- <div class="text_1">快速用电</div> -->
          </div>
          <div class="flex-col">
            <img src="../assets/image/z-2.png" alt="" class="img-item_2" />
            <!-- <span class="text_1">多种模式</span> -->
          </div>
          <div class="flex-col">
            <img src="../assets/image/z-3.png" alt="" class="img-item_3" />
            <!-- <span class="text_1">用电透明</span> -->
          </div>
        </div>
        <div class="title_1">热推精品</div>
        <div class="section-one flex-row justify-between">
          <div class="img_1">
            <div class="text-more">更多</div>
          </div>
          <div v-for="(item,i) in 8" :key="i">
            <HomeListCard></HomeListCard>
          </div>
        </div>
        <div class="title_1 title_2 flex-row justify-between items-center">
          <div>推荐发电车</div>
          <div class="flex-row">
            <div class="title-text">更多</div>
            <img src="../assets/image/img_6.png" alt="" class="img-go" />
          </div>
        </div>
        <div class="flex-row">
          <div class="img_left_1">
            <div class="btn-top">推荐</div>
            <div class="btn-more">更多</div>
          </div>
          <div class="flex-row wrap justify-between card-right">
            <div v-for="(item,i) in 8">
              <HomeListCard></HomeListCard>
            </div>
          </div>
        </div>
        <div class="title_1 title_2 flex-row justify-between items-center">
          <div>推荐蓄电池</div>
          <div class="flex-row">
            <div class="title-text">更多</div>
            <img src="../assets/image/img_6.png" alt="" class="img-go" />
          </div>
        </div>
        <div class="flex-row">
          <div class="img_left_1 img_left_2">
            <div class="button-more">更多</div>
          </div>
          <div class="flex-row wrap justify-between card-right">
            <div v-for="(item,i) in 8">
              <HomeListCard></HomeListCard>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import HomeListCard from './homeListCard.vue'
  export default {
    components: {
      HomeListCard
    },
	data(){
		return {
			
		}
	}
  }
</script>

<style scoped>
  /* ---------------- 轮播图部分 start---------------------- */
  /* 展示内容容器 */
  .el-carousel__item {
    background: burlywood;
  }

  /* 指示器 */
  .outer>>>.el-carousel__indicators {
    bottom: .79rem;
    display: flex;
  }

  .outer>>>.el-carousel__indicators .el-carousel__indicator {
    padding: 0;
    align-self: end;
  }

  /* 指示器按钮 */
  .outer>>>.el-carousel__button {
    opacity: 1;
    width: .06rem;
    height: .06rem;
    border-radius: 50%;
    background-color: #fff;
    box-shadow: 0 0 0 .01rem rgba(0, 0, 0, 0.25);
    margin-right: .16rem;

  }

  /* 指示器激活按钮 */
  .outer>>>.is-active .el-carousel__button {
    width: .18rem;
    height: .06rem;
    border-radius: .03rem;
    background-color: #fff;

  }

  /* 左右切换按钮 */
  .outer>>>.el-carousel__container .el-carousel__arrow {
    background: rgba(0, 0, 0, .37);
  }

  .outer>>>.el-carousel__container .el-carousel__arrow:hover {
    background-color: rgba(31, 45, 61, .5);
  }

  .outer>>>.el-carousel__container button:nth-child(1) {
    left: 2.01rem;
  }

  .outer>>>.el-carousel__container button:nth-child(2) {
    right: 2.01rem;
  }

  /* ---------------- 轮播图部分end---------------------- */
  .content {
    background: #F5F5F5;
  }

  .center {
    width: 15.2rem;
    margin: 0 auto;
    position: relative;
    padding: 1.17rem 0 1.63rem;
  }

  .zhanshi {
    position: absolute;
    top: -0.45rem;
    box-sizing: border-box;
    width: 15.2rem;
    height: 1.14rem;
    margin: 0 auto;
    padding: 0 2.72rem 0 2.73rem;
    z-index: 2;
    background: rgba(255, 255, 255, 0.83);
	backdrop-filter: blur(15px);
    border-radius: 0.1rem;
    overflow: hidden;
  }

  /* .zhanshi .text_1{
		font-size: .13rem;
		font-family: PingFang SC-Regular, PingFang SC;
		color: #FF5400;
	}
*/
  .img-item_1 {
    width: .52rem;
    height: .79rem;
    margin-top: .18rem;
    z-index: 1;
  }

  .img-item_2 {
    width: .56em;
    height: .82rem;
    margin-top: .19rem;
    z-index: 1;
  }

  .img-item_3 {
    width: .52em;
    height: .75rem;
    margin-top: .21rem;
    z-index: 1;
  }

  /* -------热推精品 start------- */
  .section-one {
    flex-wrap: wrap;
  }

  .title_1 {
    height: .39rem;
    font-size: .28rem;
    font-family: PingFang SC-Regular, PingFang SC;
    color: #333333;
    line-height: .39rem;
    margin-bottom: .22rem;
  }

  .img_1 {
    width: 5.96rem;
    height: 3.8rem;
    background: url('../assets/image/img_1.png') no-repeat;
    background-size: cover;
    position: relative;
  }

  .text-more {
    position: absolute;
    right: .39rem;
    bottom: .38rem;
    width: .61rem;
    height: .28rem;
    background: #FF5400;
    border-radius: .03rem;
    font-size: .14rem;
    font-family: PingFang SC-Regular, PingFang SC;
    color: #FFFFFF;
    line-height: .28rem;
    text-align: center;
  }

  /* -------热推精品 end-------- */
  /* -------推荐发电车 start ---- */
  .title_2 {
    margin: .34rem 0 .23rem;
  }

  .title-text {
    font-size: .14rem;
    font-family: PingFang SC-Regular, PingFang SC;
    color: #8D8D8D;
    line-height: .2rem;
    margin-right: .07rem;
  }

  .img_left_1 {
    position: relative;
    width: 2.86rem;
    height: 7.74rem;
    display: inline-block;
    background-image: url('../assets/image/img_4.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
    border-radius: .07rem;
    margin-right: .2rem;
  }

  .img_left_1 .btn-top {
    position: absolute;
    top: .97rem;
    left: .95rem;
    width: 1.04rem;
    height: .29rem;
    background: #FFFFFF;
    font-size: .14rem;
    font-family: PingFang SC-Regular, PingFang SC;
    color: #104E7D;
    line-height: .29rem;
    text-align: center;
  }

  .img_left_1 .btn-more {
    position: absolute;
    left: .38rem;
    bottom: .22rem;
    width: .61rem;
    height: .28rem;
    background: #FFFFFF;
    border-radius: .03rem;
    font-size: .14rem;
    font-family: PingFang SC-Regular, PingFang SC;
    color: #000000;
    line-height: .28rem;
    text-align: center;
  }

  .img_left_2 {
    background-image: url('../assets/image/img_5.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }

  .img_left_2 .button-more {
    position: absolute;
    left: .38rem;
    bottom: .31rem;
    width: .61rem;
    height: .28rem;
    background: #FFFFFF;
    border-radius: .03rem;
    font-size: .14rem;
    font-family: PingFang SC-Regular, PingFang SC;
    color: #000000;
    line-height: .28rem;
    text-align: center;
  }

  .card-right {
    width: 12.11rem;
  }

  .img-go {
    width: .08rem;
    height: .12rem;
    margin-top: .04rem;
  }

  /* -------推荐发电车 end ---- */
</style>
